import React, { Component, Fragment } from 'react';
import ReactModal from 'react-modal';
import { toastr } from 'react-redux-toastr';
import $ from 'jquery';
import 'jquery-mask-plugin';
import TitleModal from '../../common/form/titleModal';
import LabelAndSelectAjax from '../../common/form/labelAndSelectAjax';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelect from '../../common/form/labelAndSelect';
import api from '../../api';
import Requisition from '../../utils/requisitions/requisition';
import CONSTS from '../../config/consts';
import Language from '../../config/language';
import LoadingPage from '../../common/template/loadingPage';
import MandatoryFields from '../../common/template/mandatoryFields';
import ModalLoading from '../modals/modal-loading';
import { strPtBrMoneyToNumber, maskMoney, maskNumber, maskPercent } from '../../config/methods';

import './modal-servico.scss';

ReactModal.setAppElement('#root');

const options = CONSTS.TIPO_COMISSAO;

const CLASS_COMPONENT = {prefix:".", name:"modal-perfil-servicos"};

const INITIAL_STATE = {
  servico:'',
  valor:'',
  comissao:'',
  tipo_comissao:''
}

export default class Modal extends Component{
  constructor(props){
    super(props);

    this.state = this.initalState();
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onAfterOpen = this.onAfterOpen.bind(this);
  }

  onChangeSelect(val, name){
    this.setState({
      [name]: val
    });
  }

  handleSelect(item, name){
    this.handleInputChange({
      target: {value:item, name:name}
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if(name === "valor" || name === "comissao" || name === "tipo_comissao"){
      this.checkValues(event);
    }else{
      const data = {[name]: value};
      this.setState(data);
    }
  }

  checkValues(event){
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let convertedValue = value;
    let newState = {};

    switch (name) {
      case "valor":
        convertedValue = maskMoney(convertedValue);
        newState = { [name]: convertedValue }
        break;
      case "comissao":
        //se o tipo de comissão for 2, ou seja, dinheiro, convertemos o valor para dinheiro
        if(this.state.tipo_comissao && (this.state.tipo_comissao.value === 2)){
          newState = { [name]: maskMoney(convertedValue)}
        } else if(this.state.tipo_comissao && (this.state.tipo_comissao.value === 1)){
          newState = { [name]: maskPercent(convertedValue)}
        }else{
          newState = { [name]: maskNumber(convertedValue)}
        }
        break;
      default:
        newState = {[name]: value};
    }

    newState = this.checkTotal(newState, this.state);

    this.setState(newState);
  }

  checkTotal(prevState, currentState){
    let newState = {...currentState, ...prevState};

    if(newState.valor){
      newState.total = strPtBrMoneyToNumber(newState.valor) * newState.n_sessoes;
    }
    newState.total = '';
    if(newState.tipo_comissao && newState.comissao && newState.valor){
      const tipo_comissao = newState.tipo_comissao.value;
      const valor = Number(strPtBrMoneyToNumber(newState.valor));
      const comissao = Number(strPtBrMoneyToNumber(newState.comissao));
      const n_sessoes = 1;

      let total = (tipo_comissao === 1)
                        ? ((valor * n_sessoes) * (comissao/100))
                        : comissao;
      total = Number(total).toFixed(1);
      newState.total = String(total+"0").replace('.',',');
    }
    return newState;
  }

  initalState(){
    return {
      ...INITIAL_STATE,
      loaded: false
    };
  }

  initData(response){
    if(response.tipo_comissao){
      response.tipo_comissao = options.filter( ( elem, i, array ) => {
          return Number(elem.value) === Number(response.tipo_comissao.id);
      });

      response.tipo_comissao = response.tipo_comissao ? response.tipo_comissao[0] : null;
    }

    if(response.servico){
      response.servico = {label: response.servico.servico, value: response.servico.id};
    }

    if(response.valor){
      response.valor = response.valor.formated;
    }

    if(response.comissao){
      response.comissao = response.comissao.formated;
    }

    if(response.total){
      response.total = response.total.formated;
    }

    response.loaded = true;

    this.setState({
      ...response
    });

  }

  getTipoComissao(tipo){
    let option = options.filter( ( elem, i, array ) => {
        return Number(elem.value) === Number(tipo);
    });

    return option ? {value: option[0].label, id: option[0].vaule} : null;
  }

  onAfterOpen(){
    const { token } = this.props;
    const self = this;
    const id = this.props.item;

    if(!id)
    {
      this.setState({
        loaded: true,
        ...INITIAL_STATE
      });

      return false;
    }

    this.setState(this.initalState());

    Requisition({
      header: {
        [CONSTS.API_KEY ]: CONSTS.API_KEY_VALUE,
        'Auth' : 'Bearer '+token
      },
      type: 'get',
      url: `${api.API_URL}${api.API.perfisServicos.read.replace(/{id}/,id)}`,
      data: {},
      success: response => {
        const data = response.data;
        if(data){
          if(data.status){
            self.initData(data.data);
          }else{
            toastr.warning(Language.atencao, data.msg);
            self.props.onRequestClose();
          }
        }else{
          toastr.error(Language.erroTitle, Language.erro01);
          self.props.onRequestClose();
        }
      },
      error: response => {
        toastr.error(Language.erroTitle, Language.erro02);
        self.props.onRequestClose();
      }
    });
  }

  handleSubmit(e){
    this.update();

    e.preventDefault();
  }

  beforeSend(){
    const data = {...this.state};

    if(data.servico){
      data.servico = data.servico.value;
    }
    if(data.tipo_comissao){
      data.tipo_comissao = data.tipo_comissao.value;
    }
    if(data.valor){
      data.valor = strPtBrMoneyToNumber(String(this.state.valor));
    }
    if(data.comissao){
      data.comissao = strPtBrMoneyToNumber(String(this.state.comissao));
    }
    this.cleanPost(data);

    return data;
  }

  cleanPost(data){
    delete data.servico;
    delete data.loaded;
  }

  callLoading(show){
    this.setState({ModalLoading:show});
  }

  update(){
    const { token } = this.props;
    const self = this;
    const formData = this.beforeSend();
    const url = `${api.API_URL}${api.API.perfisServicos.update.replace(/{id}/,this.props.item)}`;

    self.callLoading(true);

    Requisition({
      header: {
        [CONSTS.API_KEY ]: CONSTS.API_KEY_VALUE,
        'Auth' : 'Bearer '+token
      },
      type: 'put',
      url: url,
      data: formData,
      success: response => {
        const data = response.data;
        if(data){
          if(data.status){
            toastr.success(Language.atencao, data.msg);

            self.props.onRequestClose({servico: data.data, type: 'update'});
          }else{
            toastr.warning(Language.atencao, data.msg);
          }
        }else{
          toastr.error(Language.erroTitle, Language.erro01);
        }
      },
      error: response => {
        toastr.error(Language.erroTitle, Language.erro02);
        self.loaded();
      },
      complete: response => {
        self.callLoading(false);
      }
    });
  }

  renderContent(){
    const url = `${api.API_URL}${api.API.servicos.autocomplete}`;
    const comissao_class = `${(this.state.tipo_comissao && this.state.tipo_comissao.value === 1) ? "mask-number" : "money-mask"}`;

    return(
      <form onSubmit={this.handleSubmit} className={CLASS_COMPONENT.name}>
        <div className='box-modal-visualizacao'>
          <button className='bt-close-modal' onClick={this.props.onRequestClose}><i className='fa fa-times'></i></button>
          <div className='box-modal-visualizacao__wrapper'>
            <TitleModal title="Serviço" />
            <div className="box-body">
              <LabelAndSelectAjax
                readOnly
                name='area'
                value={this.state.servico}
                onChange={this.onChangeSelect}
                url={url}
                token={this.props.token}
                label='Selecione o serviço'
                cols='8'
                placeholder='Digite aqui' />
              <LabelAndInput classes="money-mask" name='valor'  type="text" value={this.state.valor}  handleChange={this.handleInputChange}
                  label='Valor' cols='12 3' placeholder='' />
              <LabelAndInput classes={comissao_class} name='comissao'  type="text" value={this.state.comissao}  handleChange={this.handleInputChange}
                  label='Comissão' cols='12 3' placeholder='' />
              <LabelAndSelect name='tipo_comissao' options={options} value={this.state.tipo_comissao}   handleChange={this.handleSelect}
                label='Tipo de comissão' cols='12 3' placeholder='Digite aqui' />
              <LabelAndInput name='total'  value={this.state.total} readOnly handleChange={this.handleInputChange}
                  label='Total a receber' cols='12 3' placeholder='' />
            </div>
            <MandatoryFields />

          </div>
          <button type="submit" className="btn btn-block btn-success">Salvar</button>

        </div>
      </form>
    )
  }

  render(){
    const customStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
      },
      overlay: {
        backgroundColor: 'rgba(0,0,0,.8)'
      },
    };
    return(
      <Fragment>
        <ReactModal
          portalClassName={`${this.props.className || ''} ReactModalPortal`}
          isOpen={this.props.isOpen}
          onAfterOpen={this.onAfterOpen}
          onRequestClose={this.props.onRequestClose}
          style={customStyles}
        >
        {
          this.state.loaded ?
          this.renderContent()
          : <LoadingPage />
        }
        </ReactModal>
        <ModalLoading className='Modal_Loading' isOpen={this.state['ModalLoading']} />
      </Fragment>
    )
  }
}
